export default "__VITE_ASSET__CTJdGxb8__"